import { startCase } from 'lodash'
import { FC } from 'react'

import { PlayerColor } from 'features/board/board'

import { GreenButton, RedButton } from 'shared/components'
import { Dialog, DialogClose, DialogContent, DialogTitle } from 'shared/components/ui/dialog'

import { useGameEventContext } from '../event-context'

export const RespondDrawDialog: FC = () => {
  const { playerRequestingDraw, rejectDraw, acceptDraw } = useGameEventContext()

  return (
    <Dialog open={Boolean(playerRequestingDraw)}>
      <DialogContent className="w-11/12 max-w-[850px] rounded-xl p-5">
        <DialogTitle>{startCase(playerRequestingDraw as PlayerColor)} proposes a draw</DialogTitle>
        <DialogClose>
          <div className="flex gap-10">
            <RedButton className="w-full" text="Reject" onClick={rejectDraw} />
            <GreenButton className="w-full" text="Accept" onClick={acceptDraw} />
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
